import PropTypes from "prop-types"

import { Section, Text } from "@jewlr/storybook/info"
import { cn } from "styles/utils"

import {
  sizeChart as getSizeChart,
  averageRingSize as getAverageRingSize,
} from "./data"

const Td = ({ ...props }) => <td className="h-45 w-1/3" {...props} />
const ChartTableData = ({ className = "", ...props }) => (
  <tr
    className={cn(
      "text-14 tablet:text-16 even:bg-grey-5 text-center",
      className
    )}
    {...props}
  />
)

const VerticalSizeChart = () => {
  const sizeChart = getSizeChart()
  const averageRingSize = getAverageRingSize()
  return (
    <div>
      <div className="contained pb-40">
        <div className="tablet:mx-64 mx-16">
          <table className="w-full border-collapse">
            <thead>
              <ChartTableData className="mb-8 align-baseline">
                <Td>RING SIZE</Td>
                <Td>DIAMETER (mm)</Td>
                <Td>CIRCUMFERENCE (mm)</Td>
              </ChartTableData>
            </thead>
            <tbody>
              {sizeChart.map((size, i) => (
                <ChartTableData key={`size${i}`}>
                  <Td>{size.size}</Td>
                  <Td>{size.diameter}</Td>
                  <Td>{size.circumference}</Td>
                </ChartTableData>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Section className="mt-8" hasBg>
        <div className="contained text-left">
          <div className="mx-64">
            <Text className="text-primary">PLEASE NOTE:</Text>
            <Text>
              The average ring size for women is size {averageRingSize.women};
              the average ring size for men is size {averageRingSize.men}
              .
              <br />A ring should fit secure enough so that it will never fall
              off. It should have a loose comfortable fit when sliding it over
              your knuckle.
            </Text>
          </div>
        </div>
      </Section>
    </div>
  )
}
VerticalSizeChart.propTypes = {
  averageRingSize: PropTypes.object,
  sizeChart: PropTypes.array,
}
ChartTableData.propTypes = {
  className: PropTypes.string,
}
export default VerticalSizeChart
